import { contentKindSentenceLabel, contentKindTitleLabel, isLibraryKind, libraryKindFromMemberInput, planItemId, playbackClass, } from "@healthos/shared";
export function sharedContentKind(contentType) {
    if (isLibraryKind(contentType))
        return contentType;
    return libraryKindFromMemberInput(contentType) ?? "Article";
}
export function sharedContentTypeLabel(contentType) {
    return contentKindSentenceLabel(sharedContentKind(contentType));
}
export function sharedContentTitleLabel(contentType) {
    return contentKindTitleLabel(sharedContentKind(contentType));
}
export function planItemFromSharedContent(content) {
    const kind = sharedContentKind(content.contentType);
    const summary = content.summary ?? "";
    const readMedia = {
        summary,
        estimatedReadSeconds: content.estimatedReadSeconds,
        byline: content.byline,
        sourceContentType: content.contentType,
    };
    const playback = playbackClass(kind);
    return {
        id: planItemId(kind, content.cmsUuid),
        kind,
        poster: content.imageUrl,
        title: content.title,
        when: "Shared in Community.",
        why: summary || "Shared from Collection",
        dietaryLabels: [],
        articleMedia: kind === "Article" || kind === "Story" ? readMedia : null,
        roleModelMedia: kind === "RoleModel" ? readMedia : null,
        resetMedia: playback === "video"
            ? {
                description: summary,
                durationSeconds: content.durationSeconds ?? null,
                videoUrl: content.videoUrl ?? null,
            }
            : null,
        podcastMedia: playback === "audio"
            ? {
                summary,
                audioUrl: content.audioUrl ?? null,
                durationSeconds: content.durationSeconds ?? null,
                podcastTitle: content.podcastTitle ?? null,
                episodeNumber: null,
                seasonNumber: null,
            }
            : null,
        recipeMedia: kind === "Recipe"
            ? { summary, estimatedCookSeconds: null, tags: [], sourceContentType: content.contentType }
            : null,
    };
}
//# sourceMappingURL=shared-content.js.map